import {colorPrimitive} from '../../styles/primitives/colorPrimitive';

export interface TabSemanticStyles {
  'text-selected': string;
  'text-unselected': string;
}

export const lightTabSemanticStyles = {
  'text-selected': colorPrimitive.blurple[1000],
  'text-unselected': colorPrimitive.gray['700'],
} as const satisfies TabSemanticStyles;

export const darkTabSemanticStyles = {
  'text-selected': colorPrimitive.blurple[100],
  'text-unselected': colorPrimitive.gray['700'],
} as const satisfies TabSemanticStyles;
